import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import * as C from './styles';

export const Footer = () => {
  return (
    <C.Footer>
      <C.FooterContainer>
        {/* <C.FooterContent> */}
        {/* <C.FooterSection>
            <C.ContactInfo>
              <C.ContactItem>
                <a href="tel:+553432291313">+55 (34) 3229-1313</a>
              </C.ContactItem>
            </C.ContactInfo>
          </C.FooterSection> */}


        {/* </C.FooterContent> */}

        <C.FooterBottom>
          <C.FooterSection>
            <C.SocialLinks>
              <C.SocialLink
                href="https://www.facebook.com/getapagro#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </C.SocialLink>
              <C.SocialLink
                href="https://www.instagram.com/getapagro/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </C.SocialLink>
              <C.SocialLink
                href="https://www.youtube.com/channel/UCOCa-AfEyKhA4rATlqnN63w"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Youtube"
              >
                <FaYoutube />
              </C.SocialLink>
              <C.SocialLink
                href="https://www.linkedin.com/company/ogetap/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </C.SocialLink>
            </C.SocialLinks>
          </C.FooterSection>
          <C.Copyright>
            © {new Date().getFullYear()} GETAP - Desenvolvido por{' '}
            <a href="https://yazon.com.br" target="_blank" rel="noopener noreferrer">
              Yazon
            </a>
          </C.Copyright>
        </C.FooterBottom>
      </C.FooterContainer>
    </C.Footer>
  );
};